import { Component, Input, OnInit } from '@angular/core';
import { LoadingComponent } from '@components/shared/loading/loading.component';
import { LoadingService } from '@services/loading.service';
import { LngLatBounds } from 'maplibre-gl';
import { DeviceViewModel } from '../device-info-list-table/device-info-list-table.component';
import { DeviceInfoMapListTableComponent } from './device-info-map-list-table/device-info-map-list-table.component';
import { DeviceInfoMapComponent } from './device-info-map/device-info-map.component';

@Component({
  selector: 'app-device-info-map-container',
  standalone: true,
  imports: [
    DeviceInfoMapListTableComponent,
    DeviceInfoMapComponent,
    LoadingComponent,
  ],
  templateUrl: './device-info-map-container.component.html',
  styleUrl: './device-info-map-container.component.scss',
})
export class DeviceInfoMapContainerComponent implements OnInit {
  /** デバイス情報 */
  @Input({ required: true }) deviceList: DeviceViewModel[] = [];

  /** デバイス種類のリスト */
  @Input({ required: true }) deviceTypes: string[] = [];

  /** 選択されているデバイス情報 */
  public selectedDevice?: DeviceViewModel;

  /** 選択されたマーカー */
  public selectedMarker: DeviceViewModel | undefined;

  /** マップ表示範囲 */
  public mapBounds: LngLatBounds | undefined;

  /** マップがロード中か */
  public isMapLoaded = false;

  constructor(private loadingService: LoadingService) {}

  ngOnInit(): void {
    this.loadingService.show();
  }

  /**
   * 選択済みデバイス情報を設定する。
   * @param device デバイス情報
   */
  public selectDevice(device: DeviceViewModel | undefined): void {
    this.selectedDevice = device;
  }

  /**
   * 地図のロードが完了した時
   */
  public onMapLoaded(): void {
    this.isMapLoaded = true;
  }

  /**
   * 地図の移動が終了した時
   * @param bounds 地図表示範囲
   */
  public onMapMoveEnd(bounds: LngLatBounds): void {
    this.mapBounds = bounds;

    this.loadingService.hide();
  }

  /**
   * 選択されたマーカ－が変更された時、そのデバイスの情報を選択済みデバイス情報として設定する
   * @param marker マーカー
   */
  public onMarkerChanged(marker: DeviceViewModel | undefined): void {
    this.selectDevice(marker);
  }
}
